import { useSiteConfig } from 'mf_core/config';
import { useEffect, useRef } from 'react';

export function useAddMetaTag() {
  const { siteCode } = useSiteConfig();
  const isTagInjected = useRef(false);
  useEffect(() => {
    try {
      if (siteCode === 'us' && !isTagInjected.current) {
        const scriptEl = document.createElement('meta');
        scriptEl.name = 'google-site-verification';
        scriptEl.content = 'JQpoPwtLvuITXOrPPLlAyOLFC1TRoT8fLrLFCa0MIYQ';
        document.head.appendChild(scriptEl);
        isTagInjected.current = true;
      }
    } catch (e) {
      console.error(e);
    }
  }, [siteCode]);
}
